chat:
  actions:
    retry: Retry
  message:
    character-name:
      airi: Xiao Nai
      core-system: Core System
      you: You
  reasoning: Reasoning
  sessions:
    title: Conversations
    new: + New
    empty: No conversations yet
    cloud-badge: Synced to cloud
    new-chat-fallback: New chat
    delete: Delete conversation
message: Say something...
send-mode:
  title: Send key
  enter: Enter
  ctrl-enter: Ctrl + Enter
  double-enter: Double Enter
operations:
  load-models: Load Models
  load-models-status:
    loading: Loading
    ready: Ready
select-a-audio-input: Select a Audio Input
select-a-model: Select a model
select-a-voice: Choose a voice
viewers:
  debug-menu:
    emotions: Emotions
    emotions-btn:
      angry: 😠 Angry
      awkward: 😳 Awkward
      happy: 😄 Happy
      neutral: 🙂 Neutral
      question: 🤔 Question
      sad: 😫 Sad
      surprised: 🤯 Surprised
      think: 🤨 Think
    vrm:
      camera: Camera
      model:
        title: Model
profile-switcher:
  no-profile: No Profile
  no-profiles: No profiles yet
  save-as-new: Save as New Profile
  new-profile-name: Profile name
  manage: Manage Profiles
promo-banner:
  items:
    signin:
      watermark: Moon
      fallbackLabel: Moon Gift
      title: 7-Day Sign-In
      eventName: Sign in to claim stardust, avatar frames, and launch gifts.
      date: 03/28 - 04/10
      reward: Up to 120 Stardust
      cta: Sign In
    build:
      watermark: Build
      fallbackLabel: Build Bonus
      title: Supply Box Bonus
      eventName: Finish construction tasks to earn bonus vouchers and double materials.
      date: 03/30 - 04/12
      reward: 5 Supply Vouchers + Upgrade Materials
      cta: View Tasks
    spring:
      watermark: Spring
      fallbackLabel: Spring Draw
      title: Capsule Carnival
      eventName: Join the spring draw to unlock bubbles, charms, and themed furniture.
      date: 04/01 - 04/18
      reward: Half-Price First Pull + Rare Charm
      cta: Draw Now
    coupon:
      watermark: Talk
      fallbackLabel: Coupon
      title: Top-Up Coupon
      eventName: Finish chat interactions to claim coupons for expansion and voice packs.
      date: 04/02 - 04/20
      reward: Save 6 on 30 / Save 15 on 68
      cta: Claim Coupon
    home:
      watermark: Home
      fallbackLabel: Room Theme
      title: Spring Theme Update
      eventName: Unlock window, desk, and night-lamp themes to refresh your room.
      date: 04/05 - 04/22
      reward: Free Theme Draw Ticket on Sign-in
      cta: View Theme
waiting: Waiting
websocket-status:
  connected: Connected
  disconnected: No connection
  open-settings: Open connection settings
